import styled from '@emotion/styled'
import { Divider as MuiDvider } from '@mui/material'
import { memo, type ReactElement, type ReactNode } from 'react'

import { borderStroke } from '../../foundations/border-stroke-tokens.ts'
import { colorTokens } from '../../foundations/color-tokens.ts'
import { Text } from '../../foundations/text/index.ts'

export type DividerProps = {
  orientation: 'horizontal' | 'vertical'
  className?: string | undefined
  children?: ReactNode
}

export const Divider = memo(function Divider(props: DividerProps): ReactElement {
  const { orientation, children, ...otherProps } = props

  if (orientation === 'horizontal') {
    if (!children) {
      return <HorizontalDivider {...otherProps} />
    }

    return (
      <MuiDvider>
        <Text variant="body2SemiBold" color={colorTokens['color-text-base-disable']}>
          {children}
        </Text>
      </MuiDvider>
    )
  }

  return <VerticalDivider {...otherProps} />
})

export const VerticalDivider = styled('div', {
  shouldForwardProp: (propName) => !['width', 'backgroundColor'].includes(propName),
})<{
  width?: string
  backgroundColor?: string
}>`
  flex-shrink: 0;
  width: ${({ width = borderStroke[20] }) => width} !important;
  height: auto;
  background-color: ${({ backgroundColor = colorTokens['color-stroke-base-basic'] }) => backgroundColor};
  box-sizing: border-box;
`

export const HorizontalDivider = styled('div', {
  shouldForwardProp: (propName) => !['height', 'backgroundColor'].includes(propName),
})<{
  height?: string
  backgroundColor?: string
}>`
  flex-shrink: 0;
  height: ${({ height = borderStroke[20] }) => height} !important;
  width: auto;
  background-color: ${({ backgroundColor = colorTokens['color-stroke-base-basic'] }) => backgroundColor};
  box-sizing: border-box;
`
